import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Buttons from '../../../../../../../../components/forms/Buttons';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../../store';
import { manifestStagedShipmentThunk } from '../../../../../../../../store/stagedShipmentManifest/thunks';
import {
  manifestStagedShipmentHasErrorSelector,
  manifestStagedShipmentIsBusySelector,
  manifestStagedShipmentResponseSelector,
} from '../../../../../../../../store/stagedShipmentManifest/selectors';
import { Loader, Message } from '@omnigenbiodata/ui';
import ROUTES from '../../../../../../../../core/constants/routes.constants';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { resetManifestStagedShipment } from '../../../../../../../../store/stagedShipmentManifest';
import { resetStagedShipmentMeta } from '../../../../../../../../store/stagedShipmentMetaList';
import { resetShipmentList } from '../../../../../../../../store/stagedShipmentList';

interface ConfirmationModalProps {
  staged: any | null;
  isOpen: boolean;
  onClose: () => void;
  t: any;
}

const ConfirmationModal = ({ isOpen, onClose, staged, t }: ConfirmationModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const manifestIsBusy = useAppSelector(manifestStagedShipmentIsBusySelector);
  const manifestResponse = useAppSelector(manifestStagedShipmentResponseSelector);
  const manifestError = useAppSelector(manifestStagedShipmentHasErrorSelector);

  const onConfirm = () => {
    dispatch(manifestStagedShipmentThunk());
  };

  useEffect(() => {
    if (manifestResponse && manifestResponse.shipmentId) {
      dispatch(resetManifestStagedShipment());
      dispatch(resetStagedShipmentMeta());
      dispatch(resetShipmentList());

      console.log('manifestResponse==', manifestResponse);
      onClose();
      navigate(ROUTES.shippingView.replace(':shippingId', manifestResponse.shipmentId));
    }
  }, [dispatch, manifestResponse, navigate, onClose]);

  return (
    <Dialog
      open={isOpen}
      maxWidth="md"
      fullWidth
      onClose={onClose}
      aria-labelledby="shipping-confirm-modal"
      data-testid="shipping-confirm-modal"
    >
      <DialogTitle id="end-dialog-title">
        <Typography my={1} variant="h4" component="div" align="center">
          {t('manifestShipment.confirm.title')}
        </Typography>
        <Typography variant="body1" align="center">
          {t('manifestShipment.confirm.text', {
            sampleTotal: staged ? staged.totalAliquotCount : 0,
            boxTotal: staged ? staged.cryoboxes.length : 0,
          })}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Container maxWidth="sm">
          {manifestError.hasError && <Message severity="error">{manifestError.message}</Message>}
        </Container>
        <Loader
          data-testid="manifest-message"
          isVisible={manifestIsBusy}
          label={t('loaders.manifestShipment') as string}
        />
      </DialogContent>
      <DialogActions>
        <Box px={2} pb={2} width="100%">
          <Buttons
            forwardLabel={t('buttons.confirm')}
            onForward={onConfirm}
            onBack={onClose}
            backLabel={t('buttons.back')}
          />
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
